
<template>

<v-container fluid grid-list-lg grid-list-md>
    <v-stepper v-model="e1">
        <v-stepper-header>
          <template v-for="(item, index) in stepper.steps">
            <v-stepper-step  :complete="e1 > index+1" :step="index+1" @click="e1 = index+1" :color="stepper.color.complete">{{ item.name }} </v-stepper-step>
            <v-divider v-if="index < stepper.steps.length"></v-divider>
          </template>
        </v-stepper-header>
        <v-stepper-items>
          <template v-for="(item, index) in stepper.steps">
            <v-stepper-content :step="index+1">
                <v-layout row wrap>
                    <v-flex xs12>
                        <dynamic-detail :details="item.details" :stepper="stepper" />
                    </v-flex>
                </v-layout>
                <v-btn :color="button.color.default" @click="setGlobalValues(); e1 = index+2" dark>
                    {{ item.next }}
                </v-btn>
                <v-btn flat>Cancel</v-btn>
            </v-stepper-content>
            </template>
        </v-stepper-items>
    </v-stepper>
</v-container>

</template>

<script>

import {
    createNamespacedHelpers
}
from 'vuex';
const {
    mapState, mapActions, mapGetters, mapMutations
} = createNamespacedHelpers('users');

import {
    upsertContent, getContent, createContent
}
from '@/models/freedomain';

let freeDomain = createContent();

import DynamicDetail from '@/components/charts/form/dynamic-form/detail.vue';

export default {
    data: () => ({
        chart: {
          form: {

          },
          chartData: {
            id: null,
            type: "workflow",
            table: 'test_lw_workflows'
          }
        },
        foreignKey: null,
        e1: 0,
          stepper: {
            color: {complete: 'purple'},
            globalValues: {},
            steps: [
              {
                name: "Company Details",
                next: "Save Company Details",
                details: {
                    info: "",
                    rows: [{
                        type: "company-name",
                        multiple: true,
                        multipleText: "Add Another Company Name",
                        elements: [{
                            type: "input",
                            model: "name",
                            label: "Company Name",
                            class: "xs12",
                            model: null
                        }]
                    }, {
                        type: "company-details",
                        multiple: false,
                        elements: [{
                            type: "input",
                            model: "numberOfShares",
                            label: "Number Of Shares",
                            globalName: "totalNumberOfShares",
                            class: "xs6",
                            model: null
                        },
                        {
                            type: "input",
                            model: "sharePrice",
                            label: "Price Per Share (In Dalasis)",
                            globalName: "sharePrice",
                            class: "xs6",
                            model: null
                        },{
                            type: "input",
                            model: "emailAddress",
                            label: "Email Address",
                            class: "xs6",
                            model: null
                        }, {
                            type: "input",
                            model: "website",
                            label: "Website",
                            class: "xs6",
                            model: null
                        }, {
                            type: "input",
                            model: "telephoneOffice",
                            label: "Telephone (Office)",
                            class: "xs6",
                            model: null
                        }, {
                            type: "input",
                            model: "telephoneMobile",
                            label: "Telephone (Mobile)",
                            class: "xs6",
                            model: null
                        }, {
                            type: "textarea",
                            model: "address",
                            label: "Company Address",
                            class: "xs12",
                            model: null
                        }]
                    }]
                }
              },
              {
                name: "Directors And Shareholders",
                table: true,
                next: "Save ",
                details: {
                    info: "",
                    type: "table",
                    headers: [
                      {text: 'Fullname', value: 'fullname'},
                      {text: 'Email Address', value: 'emailAddress'},
                      {text: 'Nationality', value: 'nationality'},
                      {text: 'Number Of Shares', value: 'numberOfShares'},
                      {text: 'Share Percentage', value: 'sharePercentage'},
                      {text: 'Telephone', value: 'telephone'},
                      {text: 'Company Director', value: 'companyDirector'},
                      {text: ' ', value: 'actions', sortable: false }
                    ],
                    rows: [],
                    row: {
                        multiple: true,

                        multipleText: "Add Director/Shareholder",
                        elements: [{
                            type: "input",
                            name: "fullname",
                            label: "Fullname",
                            class: "xs6",
                            model: null
                        }, {
                            type: "input",
                            name: "emailAddress",
                            label: "Email Address",
                            class: "xs6",
                            model: null
                        }, {
                            type: "input",
                            name: "telephone",
                            label: "Telephone",
                            class: "xs6",
                            model: null
                        }, {
                            type: "input",
                            name: "nationality",
                            label: "Nationality",
                            class: "xs6",
                            model: null
                        }, {
                            type: "input",
                            name: "numberOfShares",
                            label: "Number Of Shares",
                            class: "xs6",
                            model: null
                        },{
                            type: "template",
                            name: "sharePercentage",
                            label: "Share Percentage",
                            class: "xs6",
                            model: "stepper.globalValues.totalNumberOfShares/item.numberOfShares"
                        },
                        {
                            type: "checkbox",
                            name: "companyDirector",
                            label: "Company Director",
                            class: "xs6",
                            model: null
                        },{
                            type: "textarea",
                            name: "address",
                            label: "Address",
                            class: "xs12",
                            model: null
                        }, {
                            type: "file",
                            name: "fileInput[]",
                            label: "Upload Identity Documents",
                            class: "xs12",
                            model: null
                        }]
                    }
                }
              },
              {
                name: "Signatures",
                next: "Save ",
                details: {
                    info: "",
                rows: [{
                    type: "directors-shareholders-signatures",
                    multiple: false,
                    multipleText: "Add Director/Shareholder",
                    elements: [{
                        type: "table",
                        dataIndex: 1,
                        label: "Fullname",
                        class: "xs12",
                        model: null
                    }
                  ]
                }
              ]
              }
            },
              {
                name: "Verify And Submit",
                next: "Save "
              },
              {
                name: "Company Formation",
                next: "Save "
              }
            ]
          },
          button: {
            color: {default: 'purple'}
          },

    }),
    components: {
        'dynamic-detail': DynamicDetail
    },
    methods: {
      setGlobalValues() {
        for(let i = 0; i < this.stepper.steps.length; i++) {
          try {
            this.setStepGlobalValues(this.stepper.steps[i]);
          } catch(err) {

          }

        }
        console.log("this.stepper", this.stepper);
      },
      setStepGlobalValues(step) {
        try {
        for(let i = 0; i < step.details.rows.length; i++) {
          this.setRowGlobalValues(step.details.rows[i]);
        }
      } catch(err) {

      }
      },
      setRowGlobalValues(row) {
        for(let i = 0; i < row.elements.length; i++) {
          this.setElementGlobalValues(row.elements[i]);
        }
      },
      setElementGlobalValues(element) {
        try {
          this.stepper.globalValues[element.globalName] = element.model;
        } catch(err) {

        }
      },
        appendRows(rows, index) {
                let row = this.nullifyElements(rows[index]);
                rows.splice(index, 0, row);
            },
            nullifyElements(row) {
                let r = {...row
                };
                for (let i = 0; i < r.elements.length; i++) {
                    r.elements[i].model = null;
                }
                return r;
            }
    },
    async mounted() {
      if(this.chart.data.id) {
        this.freeDomain = await getContent(this.chart.data.table, this.chart.data.id);
        //stepper
      } else {
        freeDomain.content = Object.assign({...this.stepper});
        this.freeDomain = await upsertContent(table, this.freeDomain);
      }
        // this.$validator.localize('en', this.dictionary);
    }
}

</script>
